import { MUTATIONS } from './constants'
import layerService from '@/api/layerService'
import { initialViewState } from './state'
import { FlyToInterpolator } from '@deck.gl/core'

const TRANSITION_DURATION = 750
const ZOOM_TRANSITION_DURATION = 250

export const mutations = {
  [MUTATIONS.CENTER_BBOX]: (state, { bbox, maxZoom = 20, duration, speed }) => {
    // bbox must be of the shape [[lng1, lat1], [lng2, lat2]]
    // TODO: enforce this shape and throw an error with a invalid one
    const viewport = layerService.deckInstance.layerManager.context.viewport
    const { latitude, longitude, zoom } = viewport.fitBounds(bbox)
    const viewState = {
      ...state.viewState,
      longitude,
      latitude,
      zoom: Math.min(maxZoom, zoom - 1),
      transitionDuration: duration || undefined,
      transitionInterpolator: duration ? new FlyToInterpolator({ speed }) : undefined
    }
    state.viewState = viewState
    layerService.deckInstance.setProps({ viewState: { ...viewState } })
  },
  [MUTATIONS.FLY_TO]: (state, { longitude, latitude, zoom }) => {
    const viewState = {
      ...state.viewState,
      longitude,
      latitude,
      zoom,
      transitionDuration: TRANSITION_DURATION,
      transitionInterpolator: new FlyToInterpolator()
    }
    state.viewState = viewState
    layerService.deckInstance.setProps({ viewState: { ...viewState } })
  },
  [MUTATIONS.ZOOM_IN]: (state) => {
    const zoom = state.viewState.zoom
    const viewState = {
      ...state.viewState,
      zoom: zoom + 1,
      transitionDuration: ZOOM_TRANSITION_DURATION,
      transitionInterpolator: new FlyToInterpolator()
    }
    state.viewState = viewState
    layerService.deckInstance.setProps({ viewState: { ...viewState } })
  },
  [MUTATIONS.ZOOM_OUT]: (state) => {
    const zoom = state.viewState.zoom
    const viewState = {
      ...state.viewState,
      zoom: zoom - 1,
      transitionDuration: ZOOM_TRANSITION_DURATION,
      transitionInterpolator: new FlyToInterpolator()
    }
    state.viewState = viewState
    layerService.deckInstance.setProps({ viewState: { ...viewState } })
  },
  [MUTATIONS.SET_VIEWSTATE]: (state, viewState) => {
    state.viewState = viewState
    layerService.deckInstance.setProps({ viewState: { ...viewState } })
  },
  [MUTATIONS.RESET_VIEWSTATE]: (state) => {
    const viewState = initialViewState()
    state.viewState = viewState
    layerService.deckInstance.setProps({ viewState: { ...viewState } })
  }
}
